import React from 'react';

const Articles = ({ articles }) => {
  return (
    <div className="pt-24 pb-16">
      <div className="section">
        <div className="max-w-7xl mx-auto">
          <h1 className="section-title text-center">Cloud & DevOps Articles</h1>
          <p className="text-gray-400 text-center max-w-3xl mx-auto mt-4">
            Insights, guides, and tutorials on cloud infrastructure, DevOps practices, and AWS solutions.
          </p>
          
          {/* Articles Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map(article => (
              <a 
                key={article.id} 
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="card overflow-hidden group h-full flex flex-col"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={article.image} 
                    alt={article.title} 
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-900 to-transparent opacity-70"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <span className="text-xs font-medium bg-primary-600 px-2 py-1 rounded">
                      {new Date(article.published_date).toLocaleDateString()}
                    </span>
                  </div>
                </div>
                <div className="p-6 flex-grow flex flex-col">
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-primary-400 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-400 mb-4 flex-grow">
                    {article.summary}
                  </p>
                  <div className="flex items-center text-primary-400 font-medium mt-auto">
                    Read on Medium
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </a>
            ))}
          </div>
          
          {/* Medium profile call to action */}
          <div className="mt-16 card p-8 bg-gradient-to-r from-dark-800 to-dark-700">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="mb-6 md:mb-0">
                <h3 className="text-2xl font-bold text-white mb-3">Follow My Medium Publications</h3>
                <p className="text-gray-400 max-w-2xl">
                  Stay updated with my latest articles, tutorials, and guides on cloud infrastructure and DevOps practices.
                </p>
              </div>
              <div>
                <a 
                  href="https://medium.com/@Fraser.fj" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary flex items-center"
                >
                  <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>
                  </svg>
                  View Medium Profile
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;